export class StreamingHttpClient {
    constructor() {
        this.bps = 0;
    }
    async fetchText_m(url) {
        const { data, bps } = await this.fetchData_m(url, 'text');
        this.bps = bps;
        return data;
    }
    async fetchChunk_m(url) {
        const { data, bps } = await this.fetchData_m(url, 'arrayBuffer');
        this.bps = bps;
        return data;
    }
    async fetchChunkAndAppend_m(chunkUrl, sourceBuffer) {
        const buffer = await this.fetchChunk_m(chunkUrl);
        return new Promise((resolve, reject) => {
            sourceBuffer.addEventListener('updateend', () => resolve(), { once: true });
            try {
                sourceBuffer.appendBuffer(buffer);
            }
            catch (error) {
                reject(error);
            }
        });
    }
    async fetchData_m(url, responseType) {
        const start = performance.now();
        const response = await fetch(url);
        if (!response.ok) {
            throw new Error(`Error fetching: ${url}`);
        }
        let data;
        if (responseType === 'text') {
            data = await response.text();
        }
        else if (responseType === 'arrayBuffer') {
            data = await response.arrayBuffer();
        }
        else {
            throw new Error(`Invalid response type: ${responseType}`);
        }
        const end = performance.now();
        const seconds = (end - start) / 1000;
        let bytes = +(response.headers.get('Content-Length') || 0);
        if (!bytes) {
            // fallback to calculate size from fetched data
            bytes = data instanceof ArrayBuffer ? data.byteLength : new Blob([data]).size;
        }
        const bps = calculateBitsPerSecond(bytes, seconds);
        console.debug({ bytes, duration: seconds.toFixed(2), bps });
        return { data, bps };
    }
}
function calculateBitsPerSecond(bytes, seconds) {
    const B = Number(bytes);
    const b = B * 8;
    return Math.round(b / seconds);
}
